import { WidthContainer } from '@pata-app/ui-document';

import React from 'react';

import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import TopFeatureTile from './topFeatureTile';
import { TOP_FEATURES_TITLES_CONFIG } from './topFeatures.config';
import { TilesContainer } from './topFeatures.styled';

const TopFeatureTitle = () => {
  return (
    <TextWithHighlight>
      <h2 style={{ textAlign: 'center', maxWidth: '800px', margin: 'auto' }}>
        Simplify bookings with secure payments and notes in one place on our pet massage therapy platform
      </h2>
    </TextWithHighlight>
  );
};

export function TopFeatures() {
  return (
    <WidthContainer noBackground>
      <SectionContainer title={TopFeatureTitle}>
        <TilesContainer>
          {TOP_FEATURES_TITLES_CONFIG.map((tile, index) => (
            <TopFeatureTile
              alignment={index % 2 === 0 ? 'left' : 'right'}
              action={tile.action}
              title={tile.title}
              description={tile.description}
              imageSrc={tile.image}
            />
          ))}
        </TilesContainer>
      </SectionContainer>
    </WidthContainer>
  );
}
